import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';
const {fontRegular} = SkillzStyle.fullStyles;

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 38,
    paddingHorizontal: 16,
    paddingVertical: 9,
    borderWidth: 1,
    borderColor: '#367BCE',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  selectedBankAccountText: {
    fontSize: 13,
    ...fontRegular,
    color: '#2D2D2D',
  },
  downArrowIcon: {
    width: 30,
    height: 30,
  },
});
